module.exports = __webpack_public_path__ + "static/img/case_banner_17.497678e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_17.png
// module id = f0i4
// module chunks = 34